module.exports = __webpack_public_path__ + "img/iconNo3.59f14b27.png";